import React from 'react';
import { ScrollReveal } from './ui/ScrollReveal';
import { SectionHeading } from './ui/SectionHeading';
import { UsersIcon, HeartIcon, MessageCircleIcon, RepeatIcon, SparklesIcon, CameraIcon } from 'lucide-react';
export function DesignConnectionGrid() {
  const pillars = [{
    icon: UsersIcon,
    title: 'Audience Behavior',
    desc: 'We study who plays, how they gather, and what draws them in.'
  }, {
    icon: HeartIcon,
    title: 'Emotional Tone',
    desc: 'Every green has a mood. We design the feeling before the layout.'
  }, {
    icon: MessageCircleIcon,
    title: 'Social Flow',
    desc: 'Spaces that naturally pull people together around play.'
  }, {
    icon: RepeatIcon,
    title: 'Replayability',
    desc: 'Contours, challenges, and game modes that keep people coming back.'
  }, {
    icon: SparklesIcon,
    title: 'Memorability',
    desc: 'Moments worth talking about long after the last putt drops.'
  }, {
    icon: CameraIcon,
    title: 'Visual Shareability',
    desc: 'Every angle is designed to look incredible on camera.'
  }];
  return <section className="py-32 bg-brand-charcoal text-brand-cream-light relative overflow-hidden" data-id="element-28">
      <div className="contour-pattern absolute inset-0 opacity-10 pointer-events-none" data-id="element-29" />

      <div className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-30">
        <SectionHeading eyebrow="Our Philosophy" title="How We Design Connection" subtitle="We don't just lay turf. We engineer guest experiences. By understanding how resort guests interact in premium spaces, we design putting environments that become the most talked-about amenity on property." align="center" light className="mb-24" data-id="element-31" />

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-32">
          {pillars.map((pillar, i) => <ScrollReveal key={pillar.title} delay={i * 0.1} data-id="element-33">
              <div className="glass-panel p-8 rounded-2xl h-full group hover:bg-brand-green-deep/40 transition-colors duration-500" data-id="element-34">
                <div className="w-12 h-12 rounded-full bg-brand-gold/10 flex items-center justify-center mb-6 group-hover:bg-brand-gold/20 transition-colors duration-500" data-id="element-35">
                  <pillar.icon className="w-6 h-6 text-brand-gold" data-id="element-36" />
                </div>
                <h3 className="text-2xl font-heading text-brand-cream-light mb-3" data-id="element-37">
                  {pillar.title}
                </h3>
                <p className="text-brand-cream/70 font-body leading-relaxed" data-id="element-38">
                  {pillar.desc}
                </p>
              </div>
            </ScrollReveal>)}
        </div>
      </div>
    </section>;
}